import { render, staticRenderFns } from "./TitleNumber.vue?vue&type=template&id=661b44d4"
import script from "./TitleNumber.vue?vue&type=script&lang=js"
export * from "./TitleNumber.vue?vue&type=script&lang=js"
import style0 from "./TitleNumber.vue?vue&type=style&index=0&id=661b44d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports